import React from 'react';
import PageTemplate from '../../components/PageTemplate';
const QualityAssurance = () => {
  return <PageTemplate title="Quality Assurance" subtitle="Comprehensive Testing Services" breadcrumb="Applications > Quality Assurance"><div className="content-section"><p>Software testing, automation testing, and quality assurance services.</p></div></PageTemplate>;
};
export default QualityAssurance; 